import {
	showLoading
} from "@/components/monitoAction/track";
import {
	xdahsdkadhjads,
} from "@/api/system/h5";
let globalMonitorHandler = null
let timer = null
import {
	Toast
} from "vant";
export const trackMixin = {
	data() {
		return {
			processingLock: false,
			eventCounter: 0, // 事件计数器
			startTimestamp: null, // 计时起点
			maxThreshold: {
				count: 10, // 最大数据条数阈值（可配置）
				duration: 1 // 最大持续时间（秒，可配置）
			}
		}
	},
	created() {
		this.initMonitor()
		// this.initBt()
	},
	mounted() {
		this.$nextTick(() => {
			// 延迟执行 history 操作，确保 monito-action 已初始化
			setTimeout(() => {
				if (window.history?.pushState) {
					if (this.back_) {
						history.pushState({
							component: this._uid
						}, null, document.URL);
					} else {
						history.replaceState({
							component: this._uid
						}, null, document.URL);
					}
					window.addEventListener('popstate', this.handleCustomBack);
				}
			}, 100)
			if (!this.loading) {
				this.loading = true
				setTimeout(() => {
					showLoading()
				}, 3000)
			}
		})
	},
	beforeDestroy() {
		if (globalMonitorHandler) {
			window.removeEventListener('monito', globalMonitorHandler)
			globalMonitorHandler = null
		}
		// window.removeEventListener('monito', this.handleMonitorEvent)
		clearInterval(timer)
		window.removeEventListener('popstate', this.handleCustomBack);
		this.$hideLoading()
		this.$hideProtocolList()
	},
	methods: {
		async $agree() {
			if (this.agreeUpdate_) {
				this.agreeUpdate_()
			}
			this.$hideProtocolList()
		},
		async handleCustomBack(event) {
			if (this.back_) {
				this.back_()
			}
		},
		async $hideProtocolList() {
			if (!this.$protocolListInstance) return
			// 安全移除DOM
			const parent = this.$protocolListInstance.$el.parentNode
			if (parent) {
				parent.removeChild(this.$protocolListInstance.$el)
			}

			// 彻底销毁实例
			this.$protocolListInstance.$destroy()

			// 清除引用
			this.$protocolListInstance = null
		},
		async $hideLoading() {
			Toast.clear()
			// if (!this.$loadingInstance) return
			//
			// try {
			// 	// 等待组件隐藏动画完成
			// 	await this.$loadingInstance.hide()
			// } finally {
			// 	// 安全移除DOM
			// 	const parent = this.$loadingInstance.$el.parentNode
			// 	if (parent) {
			// 		parent.removeChild(this.$loadingInstance.$el)
			// 	}
			//
			// 	// 彻底销毁实例
			// 	this.$loadingInstance.$destroy()
			//
			// 	// 清除引用
			// 	this.$loadingInstance = null
			// }
		},
		initMonitor() {
			if (!globalMonitorHandler) {
				window.addEventListener('monito', this.handleMonitorEvent)
			}
		},

		async handleMonitorEvent(res) {
			// 检查是否需要处理数据
			if (this.processingLock) return
			try {
				this.processingLock = true
				// 初始化计时起点
				if (!this.startTimestamp) {
					this.startTimestamp = Date.now()
					this.startTimerCheck()
				}
				if (!res.detail) {
					return
				}
				// 获取 dataProcess 对象
				const dataProcess = res.detail.dataProcess || res.detail
				// 检查方法是否存在
				if (!dataProcess.getAllData || !dataProcess.getCountData) {
					console.warn('dataProcess 方法不存在，跳过处理')
					return
				}
				// 获取最新数据
				const newData = await dataProcess.getAllData(); //获取所有数据
				const countData = await dataProcess.getCountData();
				if (countData < 1) {
					return
				}
				this.eventCounter += countData
				// 双条件检查
				if (this.checkCountThreshold() || this.checkTimeThreshold()) {
					await this.processAndClearData(dataProcess, newData)
					this.resetState() // 重置状态
				}
			} finally {
				this.processingLock = false
			}

		},
		startTimerCheck() {
		if (timer) return
		timer = setInterval(() => {
			if (this.checkTimeThreshold()) {
				// 创建自定义事件来触发数据处理
				const monitoEvent = new CustomEvent('monito', {
					detail: this.$monitoAction.monitoInit.dataProcess.data.monito
				})
				window.dispatchEvent(monitoEvent)
			}
		}, 1000)
	},
		checkCountThreshold() {
			return this.eventCounter >= this.maxThreshold.count
		},
		checkTimeThreshold() {
			const elapsed = (Date.now() - this.startTimestamp) / 1000
			return elapsed >= this.maxThreshold.duration
		},
		async processAndClearData(dataProcess, data) {
			try {
				await xdahsdkadhjads(data)
				// 清空数据
				if (dataProcess.clearData) {
					await dataProcess.clearData()
				}
			} catch (e) {
				// 失败重试逻辑（可选）
				console.error('处理埋点数据失败:', e)
			}
		},
		resetState() {
			clearInterval(this.timer)
			this.eventCounter = 0
			this.startTimestamp = null
		},

	}
}
